import { Cell, Row, Skeleton } from '@vizit/atoms';
import { FEATURE_FLAGS } from '@vizit/constants';
import { useFeatureFlag } from '@vizit/feature-flags';
import { cx } from '@vizit/theme';
import * as React from 'react';
import { rowClasses } from './product-listing-row.classes';

interface ProductListingRowLoadingProps {
  /**
   * Whether to show the action column
   * @default false
   */
  showActionColumn?: boolean;
}

const ProductListingRowLoading = React.memo((props: ProductListingRowLoadingProps) => {
  const { showActionColumn = false } = props;
  const isRetailerEnabled = useFeatureFlag(FEATURE_FLAGS.APRIL_SCORING_CHANGES, false);

  return (
    <Row className={cx(rowClasses({ disabled: true }))} aria-label="Loading product row">
      <Cell>
        <div className="flex items-center gap-6 py-5 px-12">
          {/* Image */}
          <div className="flex-shrink-0 w-28 h-28">
            <Skeleton className="w-full h-full" variant="square" />
          </div>
          <div className="flex flex-col justify-center gap-1 min-w-0 w-full">
            <Skeleton className="h-12 w-1/2" variant="square" />
            <Skeleton className="h-10 w-47" variant="square" />
          </div>
        </div>
      </Cell>
      {isRetailerEnabled && (
        <Cell>
          <div className="flex items-center justify-center py-5 px-12">
            <Skeleton className="h-16 w-16" variant="square" />
          </div>
        </Cell>
      )}
      <Cell>
        <div className="flex items-center justify-center py-5 px-12">
          <Skeleton className="h-12 w-16" variant="square" />
        </div>
      </Cell>
      <Cell>
        <div className="flex items-center justify-center py-5 px-12">
          <Skeleton className="h-12 w-16" variant="square" />
        </div>
      </Cell>
      <Cell>
        <div className="flex items-center justify-start py-5 px-12">
          <Skeleton className="h-12 w-16" variant="square" />
        </div>
      </Cell>
      {showActionColumn && (
        <Cell>
          {/* Reserves the width of the two hover action buttons (refresh + delete) */}
          <div className="py-5 px-12">
            <div className="w-32" />
          </div>
        </Cell>
      )}
    </Row>
  );
});

export { ProductListingRowLoading };
export type { ProductListingRowLoadingProps };
